import styled from "styled-components"
import { motion } from "framer-motion";

export const ContainerAtencionSinTurno = styled(motion.div)`
    width: 100vw;
    height: calc(100vh - 35vh);
    display: flex;
    align-items: center;
    gap: 10px;
    flex-direction: column; 
    overflow: scroll;
    position: absolute;
    bottom: 1vh;
`;